import {repository, session} from "clientInstance";
import {TagResource, TagSetResource} from "client/resources";

const tagSeperator = "/";

const getAll = (): Promise<TagSetResource[]> => {
    return repository.TagSets.all();
};

interface GroupType {
    [tagsetId: string]: string[];
}

interface TagIndex {
    [canonicalTagName: string]: TagResource;
}

const getTagIndex = async (): Promise<TagIndex> => {
    const idx: { [canonicalTagName: string]: TagResource} = {};
    const tagSets = await getAll();
    tagSets.forEach(t => t.Tags.forEach(tag => idx[tag.CanonicalTagName] = tag));
    return idx;
};

const groupByTagSet = (canonicalTagNames: string[]): GroupType => {
    return canonicalTagNames.reduce((groups: any, ctn) => {
        const [tagSetId] = ctn.split(tagSeperator);
        (groups[tagSetId] = groups[tagSetId] || []);
        groups[tagSetId].push(ctn);
        return groups;
    }, {});
};

const flattenGroup = (groups: GroupType): string[] =>
    Object.keys(groups).reduce((a, tagId) => a.concat(groups[tagId]), []);

export {getAll, getTagIndex, groupByTagSet, flattenGroup, TagIndex};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/tenantTagsets.ts